export const ApiPaths = {
  CREATE_USER: '/user/create',
  LOGIN: () => `/customers/login`,
  SIGN_UP: `/customers/create`,
  GET_CUSTOMER_BY_ID: (id: string) => `/customers/getCustomer/${id}`,
  UPDATE_CUSTOMER: (id: string) => `/customers/update/${id}`,
  FORGOT_PASSWORD: () => `/customers/forgotPassword`,
  CHANGE_PASSWORD: () => `/customers/changePassword`,
  LOGOUT: `/customers/logout`,
  GET_HOME: "/home/getHomeData",
  GET_HOME_BANNER: () => "/home_page_banner/getDropDown",
  GET_DEAL_OFFERS: () => "/offer_banner/getDropDown",
  GET_YOUTUBES: () => "/youtube_video/getDropDown",
  GET_WEB_CONTENT_SETTINGS: () => `/web_content_setting/getDropDown`,
  GET_STATE: () => `/states/getAll`,
  GET_CITIES: () => `/city/getDropDown`,
  GET_SUBURB: () => `/suburb/getDropDown`,
  GET_SOCIAL_MEDIA_LINK: () => `/social_media_link/getDropDown`,
  GET_COMPANY_INFO: () => `/company_info/getDropDown`,
  GET_ALL_DYNAMIC_SERVICES: () => `/page/getDropDown`,
  GET_DYNAMIC_SERVICE: () => `/page/get`,
  GET_BRANDS: () => `/brands/getDropDown`,
  GET_MODELS: () => `/models/getDropDown`,
  GET_VEHICLE: () => `/vehicle_type/getDropDown`,
  GET_MOBILE_SERVICE: `/mobile_service/getAll`,
  GET_PRODUCTS: "/products/getAllProduct",
  GET_ALL_PRODUCT_BY_SLUG: `/products/getProductFromSlug`,
  GET_PRODUCT_FROM_ITEM_CODE: `/products/getProductDetails`,
  GET_PRODUCT_DROP_DOWN: "/products/getDropDownForWeb",
  CREATE_INQUIRY: '/inquiry/create',
  UPLOAD_DOCUMENT_INQUIRY: `/inquiry/uploadDocument`,
  GET_BLOGS: `/blog/getAll`,
  GET_BLOG_BY_SLUG: () => `/blog/getBySlug`,
  CREATE_FEEDBACK: '/feedback/create',
  GET_FEEDBACK_QUESTION: `/questions/getAll`,
  CREATE_ORDER: '/order/customerCreate',
  GET_ORDERS: () => `/order/getCustomerOrder`,
  INVOICE_SEND_MAIL: `/order/sendInvoiceEmail`,
  GET_ORDER_DETAILS: (id: string) => `/order/getCustomerOrderDetails/${id}`,
  CANCEL_ORDER: (id: string) => `/order/update/${id}`,
  GET_REVIEWS: `/review/getAll`,
  CREATE_REVIEW: '/review/create',
  STRIP_PAYMENT: "/payment/strip-payment",
  ZIP_PAY_PAYMENT: "/payment/zip-pay-payment",
  ZIP_PAY_STAUS_CHECK: "/payment/zip-pay-status-check",
  GET_QUOTE_DETAILS: (id: string) => `/quote/get/${id}`,
  DELETE_QUOTE: (id: string) => `/quote/delete/${id}`,
  UPDATE_QUOTE:  `/quote/update`,
  GET_VEHICLE_REGO: `/vechile_rego/getTyreInfo`,
  GET_VEHICLE_INFO_FROM_KEY: `/vechile_rego/getTyreInfoFromVehicleKey`,
};
